import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { CssBaseline, GlobalStyles } from "@mui/material"; // ✅ Added for global layout fixing

function App() {
  useEffect(() => {
    // Listen for background message triggers from the Service Worker
    const handleServiceWorkerMessage = (event) => {
      if (event.data && event.data.type === "PLAY_DING_SOUND") {
        const audio = new Audio("/ding.mp3");
        audio.play().catch((err) => console.warn("Background sound blocked:", err));
      }
    };

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", handleServiceWorkerMessage);
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", handleServiceWorkerMessage);
      }
    };
  }, []);

  return (
    <AuthProvider>
      {/* ✅ CSS Baseline and GlobalStyles eliminate default browser margins and white backgrounds */}
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: { 
            backgroundColor: "#FFFDF8", 
            margin: 0, 
            padding: 0,
            overflowX: "hidden" 
          },
          html: { 
            margin: 0, 
            padding: 0,
            overflowX: "hidden"
          }
        }}
      />
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;